const keys = {
    GET_GATEWAYS: '/gateways'
};

export default keys;

